<template>
  <div class="container">
    <div class="content-i">
      <div class="context-box">
        <div class="row justify-context-center">
          <div class="col">
            <div class="element-wrapper">
              <h3 class="element-header">
                Cadastro Realizado
              </h3>
              <div class="element-box">
                <div class="content-box">
                  <div class="row">
                    <div class="col-md-2 offset-md-2 text-right">
                      <i class="fas fa-check-circle fa-7x" style="color: green"></i>
                    </div>
                    <div class="col-md-6">
                      <h4 class="form-head">Parabéns {{ nomeUsuario }}.<br>Seu cadastro foi realizado com sucesso!</h4>
                      <div class="form-desc">
                        Agora você pode Adquirir e agendar suas consultas e ou exames diretamente pelo Site.
                      </div>
                      
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-center">
                        <button @click="toLogin" class="btn btn-primary btn-lg" role="button">Fazer Login</button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from '@/event-bus'

export default {
  mounted () {
    eventBus.$on('loginSuccess', this.handleSuccessLogin)
  },
  computed: {
    nomeUsuario () {
      return this.$store.getters.nomeUsuario
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    b64ToUtf8 (str) {
      return decodeURIComponent(escape(window.atob(str)))
    },
    parseJwt (token) {
      var base64Url = token.split('.')[1]
      var base64 = base64Url.replace('-', '+').replace('_', '/')
      return JSON.parse(this.b64ToUtf8(base64))
    },
    async handleSuccessLogin (user) {
      if (window.localStorage.getItem('compraCartao')) {
        this.$nextTick(async () => {
          let cartaoCache = JSON.parse(window.localStorage.getItem('cartaoCompra'))
          let token = window.localStorage.getItem('user')
          let userJWT = this.parseJwt(token)
          if (userJWT) {
            cartaoCache.idUser = userJWT.id
          }
          const cartao = await this.$store.dispatch('saveCartaoET', cartaoCache)
          window.localStorage.removeItem('compraCartao')
          this.$router.push({name: 'CheckoutSinSaude', query: {idTeste: cartao._id, k: cartao.pedido.plano.idPlanoZoop}})
        })
      } else {
        this.redirectToHome()
      }
    },
    toLogin () {
      eventBus.$emit('openModal', 'login')
    },
    redirectToHome () {
      this.$router.push({name: 'Home'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/cadastrese/Sucesso.vue